import { useSearchParams } from "react-router-dom";

// Post-sign-in redirect handling. A deep link (e.g. from the marketing site,
// /loads?equipment=reefer) sends an unauthenticated user through /login; we
// preserve the intended path+query so sign-in returns them exactly there — and,
// because the boards read their filters from the URL, pre-filtered as expected.

const POST_AUTH_KEY = "rt.postAuthRedirect";

/** Only allow internal absolute paths. Blocks protocol-relative ("//evil.com")
 *  and absolute external URLs so ?redirect= can't be used for open redirects. */
export function safeRedirect(raw: string | null | undefined): string {
  if (!raw) return "/";
  if (!raw.startsWith("/") || raw.startsWith("//")) return "/";
  return raw;
}

/** The validated ?redirect= target for the current login/register page. */
export function useRedirectTarget(): string {
  const [params] = useSearchParams();
  return safeRedirect(params.get("redirect"));
}

/** Persist the target across an OAuth round-trip (which leaves and re-enters the app). */
export function stashRedirect(target: string): void {
  try {
    sessionStorage.setItem(POST_AUTH_KEY, safeRedirect(target));
  } catch {
    /* storage unavailable — fall back to "/" */
  }
}

/** Consume the stashed OAuth redirect target (defaults to "/"). */
export function takeStashedRedirect(): string {
  try {
    const v = sessionStorage.getItem(POST_AUTH_KEY);
    sessionStorage.removeItem(POST_AUTH_KEY);
    return safeRedirect(v);
  } catch {
    return "/";
  }
}
